import { Message } from "../apis";
import { socket, SOCKET_EVENT } from "../services/Socket";

type UseSocketType = {
    messageThreadJoin: (id: string) => void;
    messageThreadLeave: (id: string) => void;
    messageSend: (message: Message) => void;
    userNotificationJoin: (id: string) => void;
    userNotificationLeave: (id: string) => void;
    userNotificationSend: (message: Message) => void;
};

export function useSocket(): UseSocketType {
    const messageThreadJoin = (id: string) => {
        socket.emit(SOCKET_EVENT.EMMIT.THREAD_JOIN, id);
    };

    const messageThreadLeave = (id: string) => {
        socket.emit(SOCKET_EVENT.EMMIT.THREAD_LEAVE, id);
    };

    const messageSend = (message: Message) => {
        socket.emit(SOCKET_EVENT.EMMIT.MESSAGE_SEND, message);
    };

    const userNotificationJoin = (id: string) => {
        socket.emit(SOCKET_EVENT.EMMIT.USER_NOTIFICATION_JOIN, id);
    };

    const userNotificationLeave = (id: string) => {
        socket.emit(SOCKET_EVENT.EMMIT.USER_NOTIFICATION_LEAVE, id);
    };

    const userNotificationSend = (message: Message) => {
        socket.emit(SOCKET_EVENT.EMMIT.USER_NOTIFICATION_SEND, message);
    };

    return {
        messageThreadJoin,
        messageThreadLeave,
        messageSend,
        userNotificationJoin,
        userNotificationLeave,
        userNotificationSend,
    };
}
